export default __webpack_public_path__ + "static/media/ai_governance_prohibited_ai_systems.d7c50666.svg";